import type { Recipe } from '../types';

export const LEGACY_RECIPE_OWNERSHIP_MIGRATION = {
    ownerId: 'C6gGis1nhOgKuKPDMmlD2jG2E2b2',
    householdId: 'Wg1msX1SDApzTHekgvE4',
} as const;

function normalizeId(value: string | undefined | null): string {
    return (value ?? '').trim();
}

export function shouldMigrateLegacyRecipeOwnership(
    recipe: Pick<Recipe, 'ownerId' | 'householdId' | 'isDeleted'>,
): boolean {
    if (recipe.isDeleted) return false;

    const { ownerId: targetOwnerId, householdId: targetHouseholdId } = LEGACY_RECIPE_OWNERSHIP_MIGRATION;
    const ownerId = normalizeId(recipe.ownerId);
    const householdId = normalizeId(recipe.householdId);

    if (ownerId === targetOwnerId && householdId === targetHouseholdId) {
        return false;
    }

    if (householdId === targetHouseholdId) {
        return ownerId !== targetOwnerId;
    }

    if (!householdId && !ownerId) {
        return true;
    }

    return false;
}

export function buildLegacyRecipeOwnershipPatch(now = new Date().toISOString()) {
    return {
        ownerId: LEGACY_RECIPE_OWNERSHIP_MIGRATION.ownerId,
        householdId: LEGACY_RECIPE_OWNERSHIP_MIGRATION.householdId,
        updatedAt: now,
    };
}

export function collectLegacyRecipeOwnershipCandidates(recipeLists: Recipe[][]): Recipe[] {
    const candidateMap = new Map<string, Recipe>();
    for (const list of recipeLists) {
        for (const recipe of list) {
            if (shouldMigrateLegacyRecipeOwnership(recipe)) {
                candidateMap.set(recipe.id, recipe);
            }
        }
    }
    return Array.from(candidateMap.values());
}
